import api, { getData } from '@/axiosConfig'
import { status } from '../../helpers'
import router from '@/router'
import i18n from '../../internatinalization/i18n'

import {
  LOAD_RECIPIENTS,
  SET_RECIPIENTS,
  ADD_RECIPIENT,
  LOAD_RECIPIENT,
  SET_RECIPIENT,
  CREATING_RECIPIENT,
  RESET_RECIPIENT_STATE,
  LOAD_RECIPIENT_LIST,
  SET_RECIPIENT_LIST,
  SET_RECIPIENT_ERRORS,
  SET_RECIPIENT_LIST_RECORDS,
  SET_RECIPIENT_LIST_ECOMMERCE_RECORDS,
  SET_RECIPIENT_LIST_DETAILS,
  SET_RECIPIENT_TYPE,
  CLEAR_RECIPIENT_OBJECT,
  SET_RECIPIENTLIST_TOTAL_COUNT,
  SET_SELECTED_ECOMMERCE_RECIPIENT_LIST,
  SET_ORDER_RECIPIENT_LIST,
  SET_SELECTED_RECIPIENT_LIST,
  DELETE_SELECTED_RECIPIENT_LIST
} from '../mutationTypes'
import { reportToSlack } from '@/utils/slack-error-reporter'

const gemnoteAPI = api()

export default {
  async loadRecipientList({ commit, dispatch }) {
    try {
      commit(LOAD_RECIPIENT_LIST, status.LOADING)

      const response = await gemnoteAPI.get('/team/bulk_imports')

      if (response.status == 200) {
        const data = getData(response)
        const recipientList = data.filter(
          item => item.attributes && item.attributes.recipientsCount > 0
        )
        const mappedList = recipientList.map(item => {
          return {
            created_at: item.attributes && item.attributes.createdAt,
            user: item.attributes && item.attributes.authorName,
            file_name: item.attributes && item.attributes.name,
            id: parseInt(item.id),
            totalRecords: item.attributes && item.attributes.recipientsCount,
            deletable: item.attributes && item.attributes['deletable?']
          }
        })
        commit(SET_RECIPIENT_LIST_RECORDS, mappedList)
      }
      commit(LOAD_RECIPIENT_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENT_LIST, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('recipients.action.get-recipients-error')]
          },
          { root: true }
        )
      }
    }
  },
  async loadEcommerceRecipientList({ commit }) {
    try {
      const response = await gemnoteAPI.get('/allowed_lists')
      const recipients = response.data.data.map(user => {
        return user.attributes
      })
      for (let i = 0; i < recipients.length; i++) {
        recipients[i].file_name = recipients[i].name
        recipients[i].id = response.data.data[i].id
        delete recipients[i].name
      }
      const enabledUsers = recipients.filter(recipient => {
        return recipient.enabled === true
      })
      const payload = {
        users: enabledUsers,
        type: 'single'
      }
      commit(SET_RECIPIENT_LIST_ECOMMERCE_RECORDS, recipients)
      commit(SET_SELECTED_ECOMMERCE_RECIPIENT_LIST, payload)
    } catch (error) {
      console.log(error)
    }
  },
  async setEcommerceRecipent({ dispatch }, { id, isEnable }) {
    try {
      const response = await gemnoteAPI.patch(`/allowed_lists/${id}`, {
        allow_list: {
          enabled: isEnable
        }
      })
      if (response.status == 200) {
        dispatch('loadEcommerceRecipientList')
        dispatch('groupOrder/loadAllowListEcommerce', '', { root: true })
      }
    } catch (error) {
      console.log(error)
    }
  },
  async handleImportRecipients({ commit, dispatch }, file) {
    try {
      commit(LOAD_RECIPIENT_LIST, status.LOADING)

      const formData = new FormData()
      formData.append('bulk_import[file]', file)
      const response = await gemnoteAPI.post('/team/bulk_imports', formData)

      if (response.status == 200) {
        const route = router.history.current.path.includes('/map')
        const data = getData(response)

        commit(SET_RECIPIENT_ERRORS, {})
        commit(SET_RECIPIENT_LIST, data)
        !route ? router.push('/recipient-list/map') : ''
      }
      commit(LOAD_RECIPIENT_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENT_LIST, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        const message = 'import recipients.'
        errors.push(
          i18n.t('recipients.action.recipient-exception-error' + ' ' + message)
        )
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async previewRecipients({ commit, state, dispatch }, { payload, checked }) {
    try {
      commit(LOAD_RECIPIENT_LIST, status.LOADING)
      const id = state.recipientList.id

      const response = await gemnoteAPI.post(
        `/team/bulk_imports/${id}/preview`,
        payload
      )

      if (response.status == 200) {
        const data = getData(response)
        const errors = data.attributes.errors

        if (errors) {
          return commit(SET_RECIPIENT_ERRORS, errors)
        } else {
          dispatch('importRecipientList', { id, checked })
        }
      }
      commit(LOAD_RECIPIENT_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENT_LIST, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        const message = 'validate recipients.'
        errors.push(
          i18n.t('recipients.action.recipient-exception-error' + ' ' + message)
        )
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async importRecipientList({ commit, dispatch }, { id, checked }) {
    try {
      const formData = new FormData()
      formData.append('include_headers', checked ? 'yes' : 'no')

      const response = await gemnoteAPI.post(
        `/team/bulk_imports/${id}/import`,
        formData
      )
      if (response.status == 200) {
        const data = getData(response)
        commit(SET_RECIPIENT_LIST, {})
        commit(SET_RECIPIENT_ERRORS, {})
        await router.push(`/recipient-list/${data.id}`)
      }
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENT_LIST, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        const message = 'import recipients.'
        errors.push(
          i18n.t('recipients.action.recipient-exception-error' + ' ' + message)
        )
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getRecipientListDetail(
    { commit, dispatch },
    { page = 1, perPage = 100, id }
  ) {
    try {
      commit(LOAD_RECIPIENT_LIST, status.LOADING)
      const response = await gemnoteAPI.get(
        `/team/bulk_imports/${id}/recipients?page[number]=${page}&page[size]=${perPage}`
      )
      let { totalCount } = response.data.meta
      if (response.status == 200) {
        const data = getData(response)
        commit(SET_RECIPIENT_LIST_DETAILS, data)
      }
      commit(SET_RECIPIENTLIST_TOTAL_COUNT, totalCount)
      commit(LOAD_RECIPIENT_LIST, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENT_LIST, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('recipients.action.get-recipients-error')]
          },
          { root: true }
        )
      }
    }
  },
  async handleEditRecipientList({ commit, dispatch }, payload) {
    try {
      const response = await gemnoteAPI.put(
        `/team/bulk_imports/${payload.id}`,
        {
          bulk_import: {
            name: payload.name
          }
        }
      )

      if (response.status === 200) {
        const id = router.history.current.params.id
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('Recipient List updated successfully.')]
          },
          { root: true }
        )
        if (id) {
          dispatch('getRecipientListDetail', parseInt(id))
        } else {
          dispatch('loadRecipientList')
        }
      }
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENTS, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('recipients.action.get-recipients-error')]
          },
          { root: true }
        )
      }
    }
  },
  async handleDeleteRecipientList({ dispatch }, id) {
    try {
      const response = await gemnoteAPI.delete(`/team/bulk_imports/${id}`)

      if (response.status == 204) {
        dispatch('loadRecipientList')
        if (!router.history.current.path.includes('map')) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'success',
              messages: [
                i18n.t('recipients.action.delete-recipient-update-success')
              ]
            },
            { root: true }
          )
        }
      }
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        const message = 'delete recipient.'
        errors.push(
          i18n.t('recipients.action.recipient-exception-error' + ' ' + message)
        )
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async loadRecipients({ commit, dispatch }) {
    try {
      commit(LOAD_RECIPIENTS, status.LOADING)
      const response = await gemnoteAPI.get('/team/recipients')
      const data = getData(response)
      commit(LOAD_RECIPIENTS, status.LOADED)
      commit(SET_RECIPIENTS, data)
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENTS, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('recipients.action.get-recipients-error')]
          },
          { root: true }
        )
      }
    }
  },
  async addRecipient({ commit, dispatch }, recipientObject) {
    try {
      commit(CREATING_RECIPIENT, true)
      const response = await gemnoteAPI.post(`team/recipients`, {
        name: recipientObject.name,
        email: recipientObject.email,
        address_one: recipientObject.address_one,
        address_two: recipientObject.address_two,
        phone: recipientObject.phone,
        company: recipientObject.company,
        city: recipientObject.city,
        state: recipientObject.state,
        zipcode: recipientObject.zipcode,
        country: recipientObject.country,
        salesforce_resource_uid: recipientObject.salesforce_resource_uid
      })

      let data = getData(response)
      commit(ADD_RECIPIENT, data)
      dispatch('clearMultipleOrder')

      if (
        recipientObject.salesforce_resource_uid === null ||
        recipientObject.salesforce_resource_uid === undefined
      ) {
        // if is null the recipient object comming from recipient form
        await dispatch(
          'order/setSelectdRecipient',
          {
            recipientId: data.id,
            recipientResourceType: 'gemnoteUID',
            salesForceRecipient: {}
          },
          { root: true }
        )
        commit(CREATING_RECIPIENT, false)
        const isEditing =
          parseInt(router.history.current.query.editing || '') === 1

        if (!recipientObject.disableRouteChange) {
          router.push({ name: isEditing ? 'ConfirmOrder' : 'CardMessage' })
        }
      }
    } catch (error) {
      reportToSlack({
        where: 'addRecipient',
        error: {
          message: error.message,
          stack: error.stack
        }
      })
      commit(CREATING_RECIPIENT, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('recipients.action.recipient-creation-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async updateRecipient({ dispatch }, { recipientId, addressOne }) {
    try {
      await gemnoteAPI.put(`team/recipients/${recipientId}`, {
        address_one: addressOne
      })
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('recipients.action.recipient-update-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('recipients.action.recipient-update-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async requestRecipientByEmail({ dispatch }, email) {
    try {
      let validEmail = /^[^s@]+@[^s@]+.[^s@]+$/.test(email)

      if (!validEmail) {
        let errors = []
        errors.push(i18n.t('validations.invalid-email'))
        return
      }

      await gemnoteAPI.post(`team/recipients`, {
        email,
        send_email: true
      })
      router.push({ name: 'GiftList' })
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('recipients.action.request-recipient-email-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async getRecipient({ commit, dispatch }, id) {
    try {
      commit(LOAD_RECIPIENT, status.LOADING)
      const response = await gemnoteAPI.get(`/team/recipients/${id}`)
      const data = getData(response)
      commit(LOAD_RECIPIENT, status.LOADED)
      commit(SET_RECIPIENT, data)
    } catch (error) {
      console.log(error)
      commit(LOAD_RECIPIENT, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('recipients.action.get-recipient-error')]
          },
          { root: true }
        )
      }
    }
  },
  resetRecipientState({ commit }) {
    commit(RESET_RECIPIENT_STATE)
  },
  setRecipientType({ commit }, value) {
    commit(SET_RECIPIENT_TYPE, value)
  },
  setSelectedRecipientList({ commit }, value) {
    commit(SET_ORDER_RECIPIENT_LIST, value)
  },
  setRecipientList({ commit }, value) {
    commit(SET_SELECTED_RECIPIENT_LIST, value)
  },
  removeSelectedRecipient({ commit }, id) {
    commit(DELETE_SELECTED_RECIPIENT_LIST, id)
  },
  clearRecipientObject({ commit }) {
    commit(CLEAR_RECIPIENT_OBJECT)
  },
  clearMultipleOrder({ commit, dispatch }) {
    commit(SET_SELECTED_RECIPIENT_LIST, {})
    dispatch('order/resetInventoryCheck', [], { root: true })
  },

  setOrderSelectedRecipientList({ commit }, value) {
    commit(SET_ORDER_RECIPIENT_LIST, value)
  }
}
